export default (profile) => ({
  firmName: profile?.company?.name,
  firmPIB: profile?.company?.idNumber,
  firmLocation: profile?.company?.contacts?.location ?? "",
  firmWebsite: profile?.company?.contacts?.web ?? "",
  firmApplink: "",
  firmPhone: profile?.company?.contacts?.telephone ?? "",
  firmLogo: profile?.image,
});
